import { css } from '@emotion/react'
import { VFlow } from 'bold-ui'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { useCallback } from 'react'
import { metaPath } from 'util/metaPath'

import { MedicamentoFormModel } from '../../model-prescricao'
import { PrescricaoMedicamentoPlanoModel } from '../../PrescricaoMedicamentoView'
import {
  MedicamentoPrescricaoDigitalSelected,
  PrescricaoDigitalFormModel,
} from '../prescricao-digital/model-prescricaoDigital'
import { MedicamentoItem } from './MedicamentoItem'

const path = metaPath<PrescricaoMedicamentoPlanoModel>()

interface EncaminharPrescricaoMedicamentoItemProps {
  prescricaoDigital: PrescricaoDigitalFormModel
  medicamentosToPrint: MedicamentoFormModel[]
  medicamentoIdsSelecionado: ID[]
  onChange(checked: boolean, medicamento: MedicamentoFormModel): void
  disableReceitaControlada?: boolean
  isPrescricaoDigital?: boolean
  medicamentoSelected?: MedicamentoPrescricaoDigitalSelected
  isReimpressao?: boolean
}

export function EncaminharPrescricaoMedicamentoItem(props: EncaminharPrescricaoMedicamentoItemProps) {
  const {
    prescricaoDigital,
    medicamentosToPrint,
    medicamentoIdsSelecionado,
    disableReceitaControlada = false,
    onChange,
    isPrescricaoDigital,
    medicamentoSelected,
    isReimpressao,
  } = props

  const {
    input: { value: alreadyPrintedValue },
  } = usePecField({ name: path.alreadyPrinted })

  const isPrinted = useCallback((medicamentoId: ID) => !!alreadyPrintedValue?.includes(medicamentoId), [
    alreadyPrintedValue,
  ])

  const isSelecionado = useCallback((medicamentoId: ID) => medicamentoIdsSelecionado.includes(medicamentoId), [
    medicamentoIdsSelecionado,
  ])

  return (
    <VFlow
      vSpacing={0.5}
      style={css`
        margin-top: 0.5rem;
        margin-bottom: 1rem;
      `}
    >
      {medicamentosToPrint.map((medicamento, index) => (
        <MedicamentoItem
          index={index}
          medicamento={medicamento}
          prescricaoDigital={prescricaoDigital}
          isPrescricaoDigital={isPrescricaoDigital}
          disableReceitaControlada={disableReceitaControlada}
          isPrinted={isPrinted}
          isReimpressao={isReimpressao}
          onChange={onChange}
          checked={isSelecionado}
          medicamentoSelected={medicamentoSelected}
          key={medicamento.id}
        />
      ))}
    </VFlow>
  )
}
